import '@polymer/polymer/polymer-legacy.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
class BindPath extends PolymerElement {
  static get is() {
    return 'bind-path';
  }
  static get properties() {
    return {
      base: {
        type: Object,
        notify: true
      },
      createNonexistentPath: {
        type: Boolean,
        value: false
      },
      log: {
        type: Boolean,
        value: false
      },
      path: {
        type: String,
        observer: '_pathChanged'
      },
      value: {
        type: Object,
        notify: true
      },
      verbose: {
        type: Boolean,
        value: false
      }
    };
  }
  static get observers() {
    return ['_valueChanged(value.*)'];
  }
  _changeHandler(change) {
    if (this._validPath) {
      // List of path properties for the data that has been changed. i.e '[base, some, path, property]'.
      let changePathParts = change.path.split('.').filter((x) => x);
      // List of path properties for value. i.e. '[some, path]'
      let valuePathParts = this.path.split('.').filter((x) => x);
      // Path the set data to.
      let setPath = null;
      // Path to get data from.
      let getPath = null;
      // If base object is changed and the change path is above, equal to, or below the value path.
      if (
        changePathParts[0] == 'base' &&
        (valuePathParts.every((part, i) => part == changePathParts[i + 1]) ||
          changePathParts.slice(1).every((part, i) => part == valuePathParts[i]))
      ) {
        // List of path properties for the data that has been changed that are below the value path.
        let relChangePathParts = changePathParts.slice(valuePathParts.length + 1);
        setPath = ['value'].concat(relChangePathParts).join('.');
        getPath = ['base'].concat(valuePathParts, relChangePathParts).join('.');
      }
      // If the value object is changed (has to be within the path of base already, so no need to check).
      else if (changePathParts[0] == 'value') {
        setPath = ['base'].concat(valuePathParts, changePathParts.slice(1)).join('.');
        getPath = changePathParts.join('.');
      }
      if (setPath != null && getPath != null) {
        // Get data at both locations.
        let setData = this.get(setPath);
        let getData = this.get(getPath);
        if (getData === undefined) getData = null;
        // If the data at the two locations is different then update setPath.
        if (setData != getData) {
          if (this.createNonexistentPath) {
            // This used to loop through the path and set all null parts to {}.
            // This caused value to update it's mutations to the base (as {} parts were written).
            // Instead, make getData be an object of objects such that it completes the missing parts of the path.
            // i.e. setData == {x:'hello'}, path='y.z', and getData == 'world'.
            // this.set will fail since setData.y != {}.
            // Thus, let getData = {z: 'world'} and then let setData = getData.y = getData.
            let pathParts = setPath.split('.').filter((x) => x);
            let i = pathParts.length - 1;
            for (i; i > 1; i--) {
              let tempPath = pathParts.slice(0, i).join('.');
              if (this.get(tempPath) == null) {
                let temp = {};
                temp[pathParts[i]] = getData;
                getData = temp;
              } else break;
            }
            setPath = pathParts.slice(0, i + 1).join('.');
          }
          this.log && console.log('Setting', setPath, 'from', setData, 'to', getData, 'from', getPath);
          this.set(setPath, getData);
        }
        // Otherwise, merely notify setPath that the data has been changed (javascript pass by reference can result in same data but Polymer hasn't recieved a change notification yet at setPath).
        else {
          this.log && this.verbose && console.log('Notifying', setPath, 'of change at', getPath);
          this.notifyPath(setPath);
        }
      }
    }
  }
  _pathChanged() {
    // Check to see if path is valid.
    this._validPath =
      this.path != null &&
      typeof this.path === 'string' &&
      !(this.path.startsWith('.') || this.path.endsWith('.') || this.path.includes('..'));
    if (this.path != null && typeof this.path !== 'string') this.set('path', this.path.toString());
    // Stop observing base.
    this.__observeEffects.base = [];
    // Start observing new base path.
    if (this._validPath) this._createMethodObserver(`_changeHandler(base.${this.path}.*)`);
    let setPath = 'value';
    let getPath = this._validPath ? ['base'].concat(this.path.split('.').filter((x) => x)).join('.') : '';
    let setData = this.get(setPath);
    let getData = this.get(getPath);
    if (getData === undefined) getData = null;
    this.log && console.log('Setting', setPath, 'from', setData, 'to', getData, 'from', getPath);
    this.set(setPath, getData);
  }
  _valueChanged(changeRecord) {
    this._changeHandler(changeRecord);
    this.dispatchEvent(new CustomEvent('value-changed', { detail: { value: this.value } }));
  }
}
customElements.define(BindPath.is, BindPath);
